<h2 class="f-w-500 m-b-24" mat-dialog-title><strong>Perfiles usuario</strong></h2>
<mat-card class="cardWithShadow">
	<mat-card-content class="p-16">
		<div class="row d-flex justify-content-right align-items-center">
			<div class="col-md-12 d-flex">
				<span class="example-list-section">
					<ul>					  
						<li *ngFor="let perfil of perfiles">
						  <mat-checkbox [checked]="perfil.checked" [(ngModel)]="perfil.checked" [disabled]="perfil.predeterminado || perfil.ordenJerarquia < ordenJerarquia">
							{{perfil.nombrePerfil}}
						  </mat-checkbox>
						</li>
					</ul>
				  </span>
			</div>
		</div>
		<div class="row d-flex justify-content-left">
			<div class="col-md-4 d-flex">
				<button mat-flat-button style="background-color: #7f7f7f; color: white" class="m-l-8"
				(click)="closeDialogPerfilesUsuario()">
				Cerrar
				<mat-icon class="m-r-10 cursor-pointer">cancel</mat-icon>
				</button>
			</div>
		</div>
	</mat-card-content>
</mat-card>